import type { Transaction } from '@tiptap/pm/state';

/** 換圖要寫入的新來源（媒體庫挑的或剛上傳的 R2 圖）。 */
export interface ReplaceImageInput {
  src: string;
  /** 媒體庫有替代文字才覆寫；沒有就沿用原本的 alt。 */
  alt?: string | null;
}

/** 取 NodeView 的即時位置；節點已被刪除（view 銷毀）時回傳 null，不丟例外。 */
export function resolvePos(getPos: () => number | undefined): number | null {
  try {
    const pos = getPos();
    return typeof pos === 'number' ? pos : null;
  } catch {
    return null;
  }
}

function imageAt(tr: Transaction, pos: number) {
  if (pos < 0 || pos > tr.doc.content.size) return null;
  const node = tr.doc.nodeAt(pos);
  return node && node.type.name === 'image' ? node : null;
}

/**
 * 把 pos 上那張圖換成新的 src（有 alt 才換 alt），對齊／圖說等其他屬性原封保留。
 * pos 上不是圖片 → 不動文件、回傳 false（例如挑圖期間那張圖被刪了）。
 */
export function replaceImageAt(tr: Transaction, pos: number, input: ReplaceImageInput): boolean {
  const node = imageAt(tr, pos);
  if (!node) return false;
  const attrs: Record<string, unknown> = { ...node.attrs, src: input.src, uploading: false };
  if (input.alt) attrs.alt = input.alt;
  tr.setNodeMarkup(pos, undefined, attrs);
  return true;
}

/** 上傳替換期間把該圖標成「上傳中」（顯示轉圈），失敗時再取消。 */
export function setImageUploading(tr: Transaction, pos: number, uploading: boolean): boolean {
  const node = imageAt(tr, pos);
  if (!node) return false;
  tr.setNodeMarkup(pos, undefined, { ...node.attrs, uploading });
  return true;
}
